<template>
  <div class="home">
    <LandingPageHero v-on:child-click="receiveChildClick" />
    <div class="separator"></div>
    <div class="valuesContainer" id="about">
      <ValuesCard
        v-for="(valuesObject, index) in values"
        :key="index"
        :valuesObject="valuesObject"
      />
    </div>
    <div class="separator"></div>
    <div class="networkValidationSection">
      <div class="col-1">
        <h1>Networks We Support</h1>
        <div class="col-2">
          <div class="logo">
            <h3>Cosmos</h3>
            <a
              class="link"
              href="https://www.mintscan.io/cosmos/validators/cosmosvaloper15ytx6mflyrxynjerqlud6w646v6u3qvtjtfane"
            >
              <img class="logoimg" src="../assets/NetworkLogos/cosmos.svg" />
            </a>
          </div>
          <div class="logo">
            <h3>Osmosis</h3>
            <a
              class="link"
              href="https://www.mintscan.io/osmosis/validators/osmovaloper1pgl5usqpelz3a4c04g6t3yyvlrc9yseylmtcnt"
            >
              <img class="logoimg" src="../assets/NetworkLogos/osmosis.svg" />
            </a>
          </div>
          <div class="logo">
            <h3>Juno</h3>
            <a 
              class="link"
              href="https://www.mintscan.io/juno/validators/junovaloper1vq8tw77kp8lvxq9u3c8eeln9zymn68rng8pgt4"
            >
              <img class="logoimg" src="../assets/NetworkLogos/juno.svg" />
            </a>
          </div>
          <div class="logo" style="margin: 0px;">
            <h3>Secret Network</h3>
            <a
              class="link"
              href="https://secretnodes.com/secret/chains/secret-3/validators/45521282C12E0EC1691495FCA714947DCA072745"
            >
              <img class="logoimg" src="../assets/NetworkLogos/scrt.svg" />
            </a>
          </div>
          <div class="logo">
            <h3>Terra</h3>
            <a class="link">
              <img class="logoimg" src="../assets/NetworkLogos/terra-luna.svg" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="networkValidationSection">
      <div class="col-1">
        <h1>Our Contribution</h1>
        <div class="logo">
          <a href="https://shadeprotocol.io">
            <img class="logoimg" id="shadelogo" src="../assets/NetworkLogos/shade-logo-dark.svg" />
          </a>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="aboutUsSection">
      <div class="col-1">
        <h1>About Us</h1>
        <p>
          <span
            >Since 2019, Secure Secrets has been an active member of the
            <a href="https://scrt.network/" target="_blank">Secret Network</a>
            community and contributed to building the network infrastructure as
            a validator node and software developer.
          </span>
          <br />
          <br />
          We believe privacy is a critical component to making Web 3.0 a
          reality, and the Secret Network provides the platform to bring
          programmable privacy to blockchain.
        </p>
      </div>
    </div>
    <div class="separator"></div>
    <h1>Our Team</h1>
    <div class="IDcards">
      <PersonCard
        v-for="(personObject, index) in founders"
        :key="index"
        :personObject="personObject"
      />
    </div>
    <div class="IDcards">
      <PersonCard
        v-for="(personObject, index) in people"
        :key="index"
        :personObject="personObject"
      />
    </div>
    <div class="separator"></div>
    <h2 id="newsletter">Subscribe to our Newsletter</h2>
    <Subscribe />
    <component
      v-for="(component, index) in components"
      :key="index"
      :is="component"
      :imgObject="imgObject"
      :getValidatorParameters="getValidatorParameters"
      :modalWidth="modalWidth"
    />
    <!--
    <StakingPopup
      :imgObject="imgObject"
      :getValidatorParameters="getValidatorParameters"
      :modalWidth="modalWidth"
    />
    -->
  </div>
</template>
<script>
import PersonCard from "@/components/PersonCard.vue";
import ValuesCard from "@/components/ValuesCard.vue";
import Subscribe from "@/components/Subscribe.vue";
import LandingPageHero from "@/components/LandingPageHero.vue";
import StakingPopup from "@/components/StakingPopup.vue";

export default {
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Secure Secrets | Privacy-Focused Blockchain Validator",
    // all titles will be injected into this template
    titleTemplate: null,
    meta: [
      {
        name: "description",
        content:
          "Secure Secrets is a privacy-focused blockchain validator that builds tool for users and developers in the Web 3.0 ecosystem.",
      },
    ],
  },
  components: {
    PersonCard,
    ValuesCard,
    Subscribe,
    LandingPageHero,
    StakingPopup,
  },
  name: "home",
  data: () => ({
    components: [],
    founders: [
      {
        name: "Mohammad Patla",
        title: "CEO and Founder",
        imagePath: "Mohammed.jpg",
      },
      {
        name: "Carter Woetzel",
        title: "Co-Founder",
        imagePath: "Carter.jpg",
        extras:
          "Author of <a href='/papers' target='blank'>Secret Network Graypaper</a>",
      },
    ],
    people: [
      {
        name: "Austin Woetzel",
        title: "Developer",
        imagePath: "Austin.jpg",
      },
      {
        name: "Jeremy Schipper",
        title: "Compliance & Operations Consultant",
        imagePath: "Jeremy.jpg",
      },
      {
        name: "Dalton Tanner",
        title: "Marketing & Content Consultant",
        imagePath: "Dalton.jpg",
      },
    ],

    values: [
      {
        title: "Privacy",
        imagePath: "Privacy.svg",
        description:
          "We believe privacy is a human right and is the key to unlocking the full potential of Web 3.0.",
      },
      {
        title: "Community",
        imagePath: "Community.svg",
        description:
          "We believe in the value of our decentralized community of delegators.",
      },
      {
        title: "Transparency",
        imagePath: "Transparent.svg",
        description:
          "We will always be open and honest about our commission rates, goals, and contributions to the network.",
      },
    ],
    imgObject: {
      title: "Keplr Icon",
      imagePath: "Keplr.svg",
    },
    getValidatorParameters: false,
    subscribeText: "Subscribe",
    modalWidth: "600",
  }),

  mounted() {
    this.addStakingPopup();
  },

  methods: {
    // watch for click in LandingPageHero and toggle prop for StakingPopup to initiate API queries
    addStakingPopup() {
      // set size
      if (window.innerWidth < 600 && window.innerWidth >= 500) {
        this.modalWidth = "500";
      }
      if (window.innerWidth < 500) {
        this.modalWidth = "300";
      }
      this.components.push(StakingPopup);
    },
    receiveChildClick: function () {
      this.getValidatorParameters = true;
    },
  },
};
</script>

<style scoped lang="scss">
h1 {
  font-size: 45px;
}

h2 {
  font-size: 37px;
  padding-bottom: 10px;
}

.valuesContainer {
  display: flex;
  flex-wrap: wrap;
  width: 95%;
  justify-content: space-evenly;
  margin: 0 auto;
}

.IDcards {
  text-align: center;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 auto;
  width: 100%;
}

.aboutUsSection {
  margin: 0px auto;
  width: 75%;
}

.networkValidationSection {
  margin: 0px auto;
  width: 75%;
}

.col-2 {
  margin-top: 20px;
}

.logoimg {
  height: 125px;
  width: auto;
  margin-top: 5px;
}

#shadelogo{height: 50px;}

@media only screen and (min-width: 500px){
  #shadelogo{height: 80px}
}

@media only screen and (min-width: 900px) {
  .col-2 {
    display: flex;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
  }

  #shadelogo{height: 125px;}
}

.logo {
  margin: 30px;
  white-space: nowrap;
}

.link {
  margin-top: 10px;
}

.col-1 {
  width: 75%;
  font-size: 25px;
  color: #141a3c;
  margin: 0 auto;

  p {
    padding-top: 10px;
    text-align: left;
    span {
      font-weight: bold;
    }
    a {
      color: #836145;
    }
  }
}

@media all and (max-width: 900px) {
  .col-1 {
    width: 95%;
  }
  .aboutUsSection {
    width: 90%;
  }
}

#emailInput {
  background: #fff;
  border: 2px solid #141a3c;
  outline: 0;
  padding: 9px 20px;
  border-radius: 50px;
  font-size: 14px;
  width: 200px;
  height: 20px;
  margin: 5px 0;
  margin-right: 5px;
}

.subscribe {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.separator {
  height: 75px;
}
</style>
